module.exports = __webpack_public_path__ + "media/luxury-2026/modern-detail-2f3e8c0d.jpg";